<script setup lang="ts">
import type {PasswordRequirement} from '@/ts/composables/pure/use-password-requirements';

defineProps<{
  requirements: PasswordRequirement[];
}>();
</script>
<template>
  <!-- polite live region: screen readers hear requirement state changes while
       typing without having to re-navigate the list. -->
  <ul class="password-requirements" aria-live="polite">
    <li
      v-for="requirement in requirements"
      :key="requirement.labelKey"
      :class="{'requirement-met': requirement.met}"
    >
      <q-icon :name="requirement.met ? 'check' : 'close'" size="16px" aria-hidden="true"/>
      <span>
        {{ $t(requirement.labelKey) }}
        <span class="sr-only">{{ $t(requirement.met ? 'password_requirement_met' : 'password_requirement_not_met') }}</span>
      </span>
    </li>
  </ul>
</template>
<style scoped lang="scss">
.password-requirements {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  grid-template-columns: 1fr;
  gap: var(--Spacing-spacing-2) var(--Spacing-spacing-4);

  @include screen-sm {
    grid-template-columns: repeat(2, 1fr);
  }
}

li {
  @include font-body-sm;
  display: flex;
  align-items: flex-start;
  gap: var(--Spacing-spacing-2);

  .q-icon {
    flex-shrink: 0;
    // Optically align the icon with the first text line.
    margin-top: 2px;
    color: var(--Functional-wl-error-text);
  }

  &.requirement-met .q-icon {
    color: var(--Functional-wl-completed-surface);
  }
}
</style>
